import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Checkbox } from '../../../../components/Checkbox';
import { Dropdown } from '../../../../components/Dropdown';
import { StyledDropdownButton } from '../../../../components/Dropdown/styles';
import { Tooltip } from '../../../../components/Tooltip';

export const StyledFilterContainer = styled.div`
  width: 100%;
  padding: 8px 16px;
  position: relative;
`;

export const StyledTechCategoriesDropdown = styled(Dropdown)`
  bottom: 6px;
  margin-left: 16px;
  width: calc(100% - 32px);
`;

export const StyledTechCategoriesDropdownButton = styled(StyledDropdownButton)`
  width: 100%;
  justify-content: center;
`;

export const StyledTechCategoryOption = styled.div<{ isChild: boolean }>`
  width: 100%;
  display: flex;
  ${setFontVariant('input2', colorsPalettes.carbon[500])};
  font-weight: ${({ isChild }) => (isChild ? 400 : 500)};
`;

export const StyledTechCategoryCheckbox = styled(Checkbox)<{ isChild: boolean }>`
  padding: ${({ isChild }) => (isChild ? '10px 16px 10px 38px' : '10px 16px 10px 8px')};
`;

export const StyledTechCategoryLabel = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledTechCategoryIcon = styled(SWReactIcons)`
  margin-right: 8px;
`;

export const TechCategoryApplyButton = styled.button`
  width: 100%;
  padding: 6px 12px;
  border: none;
  background-color: ${colorsPalettes.blue[400]};
  ${setFontVariant('button', colorsPalettes.carbon[0])};
  text-align: right;
  font-weight: 500;
  cursor: pointer;
`;

export const StyledTechCategoriesDropdownTooltip = styled(Tooltip)`
  width: 100%;
`;
